// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5db20ac7","977":"ed269fa9"}[chunkId] + ".chunk.js";
};